export default "__VITE_ASSET__WxyLhhJb__"